export const CN_DAYS = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
/** 数字转中文天序号，如 1→"第一天"，12→"第12天" */
export const toCnDay = (n: number) => `第${CN_DAYS[n - 1] ?? n}天`;
